import { Link } from 'react-router-dom';
import type { MediaItem } from '@/types/media';

interface MediaCardProps {
  item: MediaItem;
  showFav?: boolean;
}

export default function MediaCard({ item, showFav = true }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative h-64 w-full overflow-hidden bg-background-200 sm:h-72 lg:h-80">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} 在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-full bg-black/55 px-2 py-0.5 text-[11px] text-white">
          {item.type === 'movie' ? '电影' : '剧集'}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-2 text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="text-background-400">|</span>
          <span>{item.region}</span>
          <span className="text-background-400">|</span>
          <span className="truncate">{item.genres.slice(0, 2).join(' · ')}</span>
        </div>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500"></i>
            {(item.hits / 1000).toFixed(1)}k
          </span>
          {showFav && (
            <span className="flex items-center gap-1 text-foreground-400">
              <i className="ri-calendar-line"></i>
              {item.updatedAt}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}